<template>
  <div class="structure-list__wrapper">
    <div class="structure-list__level level">
      <p class="level__text">Поколение {{ binaryListLevel }}</p>

      <div class="level__btns">
        <button-arrow
          class="level__btn"
          :disabled="binaryListLevel === 1 || status === 'LOADING'"
          @click.native="changeLevel('previous')"
        />
        <button-arrow
          class="level__btn"
          direction="right"
          :disabled="binaryList.length === 0 || status === 'LOADING'"
          @click.native="changeLevel('next')"
        />
      </div>
    </div>

    <div class="structure-list">
      <template v-if="status === 'SUCCESS' || status === 'LOADING-MORE'">
        <structure-list-item
          v-for="user in binaryList"
          :key="user.id"
          :user="user"
        />
      </template>

      <template v-if="status === 'LOADING' || status === 'LOADING-MORE'">
        <main-loader />
      </template>
    </div>

    <main-button
      v-if="hasNextPage && status !== 'LOADING-MORE'"
      class="structure-list__btn"
      color="dark"
      title="Показать еще"
      @click.native="params.page++"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import StructureListItem from "@/components/structure/StructureListItem";
import ButtonArrow from "@/components/helpers/ButtonArrow";
import MainButton from "@/components/helpers/MainButton";
import MainLoader from "@/components/helpers/MainLoader";

export default {
  components: { MainLoader, MainButton, ButtonArrow, StructureListItem },

  data() {
    return {
      status: "LOADING",

      params: {
        binaryAccountId: null,
        level: 1,
        page: 1,
      },
    };
  },

  watch: {
    selectedBinaryAccount: function () {
      this.params.binaryAccountId = this.selectedBinaryAccount.id;
      this.params.level = 1;
      this.params.page = 1;
    },

    params: {
      deep: true,
      handler() {
        if (this.params.page === 1) {
          this.status = "LOADING";
        } else {
          this.status = "LOADING-MORE";
        }

        this.loadBinaryList(this.params)
          .then(() => {
            this.status = "SUCCESS";
          })
          .catch(() => {
            this.status = "ERROR";
          });
      },
    },
  },

  computed: {
    ...mapState({
      selectedBinaryAccount: (state) => state.auth.selectedBinaryAccount,
      binaryList: (state) => state.structure.binaryList,
      binaryListTotal: (state) => state.structure.binaryListTotal,
      binaryListLevel: (state) => state.structure.binaryListLevel,
    }),

    hasNextPage() {
      return this.binaryList.length < this.binaryListTotal;
    },
  },

  methods: {
    ...mapActions({
      loadBinaryList: "structure/loadBinaryList",
    }),

    changeLevel(type) {
      if (type === "previous") {
        if (this.binaryListLevel !== 1) {
          this.params.page = 1;
          this.params.level--;
        }
      }

      if (type === "next") {
        this.params.page = 1;
        this.params.level++;
      }
    },
  },

  mounted() {
    this.params.binaryAccountId = this.selectedBinaryAccount.id;
  },
};
</script>

<style lang="scss" scoped>
.structure-list {
  max-width: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: $space-xl;
  margin-bottom: $space-xl;

  &__search {
    max-width: 630px;
    margin-bottom: $space-xxl;
  }

  &__level {
    display: flex;
    align-items: center;
  }

  &__wrapper {
    display: flex;
    flex-direction: column;

    .level {
      &__text {
        @include text-1;
        color: $dark-primary;
        white-space: nowrap;
      }

      &__btns {
        display: flex;
        margin-left: $space-xl;
      }

      &__btn {
        &:not(:last-child) {
          margin-right: $space-l;
        }
      }

      @media (max-width: 425px) {
        &__text {
          @include body-1;
        }

        &__btns {
          margin-left: $space-l;
        }
      }
    }
  }

  &__btn {
    max-width: 180px;
  }
}
</style>
